class Video {
  $skelem = ".sk-component.VIDEO";
  isShowVideo = false;
  isShowVideoClass = false;
  code = "";
  title = "";
  pushTime = "";

  skAfterViewChecked(): void {}

  skUpdateView(): void {}

  showPlay(e, o) {
    this.isShowVideo = true;
    this.code = o.code;
    this.title = o.title;
    this.pushTime = o.pushTime;
    setTimeout(() => {
      this.isShowVideoClass = true;
    }, 10);
    this.skUpdateView();
  }

  hidePlay() {
    this.isShowVideoClass = false;
    setTimeout(() => {
      this.isShowVideo = false;
      this.code = "";
      this.title = "";
      this.pushTime = "";
    }, 400);
  }
}

export { Video };
